import axios from '../axios';
import useAuth from './useAuth';
import { useNavigate, useLocation } from "react-router-dom";

const useRefreshToken = () => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const refresh = async () => {
        try {
            const response = await axios.get('/refresh', {withCredentials: true});
            setAuth({accessToken: response.data.access_token});
            return response.data.access_token;
        } catch(err) {
            console.log(err);
            navigate('/login', { state: { from: location }, replace: true });
        }
    }
    return refresh;
};

export default useRefreshToken;